import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg
      id="Low_moderate_level_bar"
      width="300"
      height="51"
      viewBox="0 0 337 51"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_475"
            data-name="Rectangle 475"
            width="335"
            height="23"
            fill="#fff"
            stroke="#707070"
            stroke-width="1"
          />
        </clipPath>
      </defs>
      <g id="Group_3455" data-name="Group 3455" transform="translate(-20 -255)">
        <g
          id="Rectangle_476"
          data-name="Rectangle 476"
          transform="translate(21 255)"
          fill="none"
          stroke="#efefef"
          stroke-width="1"
        >
          <rect width="335" height="23" rx="11.5" stroke="none" />
          <rect x="0.5" y="0.5" width="334" height="22" rx="11" fill="none" />
        </g>
      </g>
      <text
        id="High"
        transform="translate(309 48)"
        fill="#222"
        font-size="12"
        font-family="Museo-500"
      >
        <tspan x="0" y="0">
          High
        </tspan>
      </text>
      <text
        id="Significant"
        transform="translate(143 48)"
        fill="#222"
        font-size="12"
        font-family="Museo-500"
      >
        <tspan x="0" y="0">
          Significant
        </tspan>
      </text>
      <text
        id="Low_to_Moderate"
        data-name="Low to Moderate"
        transform="translate(0 48)"
        fill="#52c463"
        font-size="12"
        font-family="Museo-500"
      >
        <tspan x="0" y="0">
          Low to Moderate
        </tspan>
      </text>
      <rect
        id="Rectangle_491"
        data-name="Rectangle 491"
        width="79"
        height="23"
        rx="11.5"
        transform="translate(2)"
        fill="#51b84d"
      />
    </svg>
  );
}

export default SvgComponent;
